import React, {
    useEffect,
    useRef,
    useState
} from "react";

import {
    ArrowLeftOutlined,
    ExpandOutlined,
    CompressOutlined,
    ReloadOutlined,
    FileTextOutlined
} from "@ant-design/icons";

import {
    useNavigate
} from "react-router-dom";

import {
    getBooksOSStoreUrl,
    isAndroidDevice,
    isIOSDevice,
    isMobileBooksOSDevice
} from "../utils/booksOs";


const PdfView = ({
    url,
    title
}) => {

    const navigate =
        useNavigate();

    const isAndroid =
        isAndroidDevice();

    const isIOS =
        isIOSDevice();

    const requiresBooksOS =
        isMobileBooksOSDevice();

    const booksOSStoreUrl =
        getBooksOSStoreUrl();

    const wrapperRef =
        useRef(null);

    const [loading, setLoading] =
        useState(true);

    const [reloadKey, setReloadKey] =
        useState(0);

    const [fullscreen, setFullscreen] =
        useState(false);


    useEffect(() => {

        const handleFullscreen = () => {

            setFullscreen(
                Boolean(
                    document.fullscreenElement
                )
            );
        };


        document.addEventListener(
            "fullscreenchange",
            handleFullscreen
        );


        return () => {

            document.removeEventListener(
                "fullscreenchange",
                handleFullscreen
            );
        };

    }, []);


    const reload = () => {

        setLoading(true);

        setReloadKey(
            value => value + 1
        );
    };


    const toggleFullscreen = async () => {

        try {

            if (
                document.fullscreenElement
            ) {

                await document
                    .exitFullscreen();

                return;
            }


            if (
                wrapperRef.current
                    ?.requestFullscreen
            ) {

                await wrapperRef.current
                    .requestFullscreen();
            }

        } catch (error) {

            console.log(
                "Fullscreen error:",
                error
            );
        }
    };


    // MOBILE_BOOKS_OS_READER_BLOCK
    if (requiresBooksOS) {
        return (
            <div className="
                fixed inset-0 z-[99999]
                flex items-center justify-center
                bg-[#f5f7fa]
                px-5
            ">
                <div className="
                    w-full max-w-[480px]
                    rounded-2xl
                    border border-red-200
                    bg-white
                    p-6
                    text-center
                    shadow-xl
                ">
                    <div className="
                        mx-auto mb-4
                        flex h-14 w-14
                        items-center justify-center
                        rounded-full
                        bg-red-50
                        text-[28px]
                    ">
                        📚
                    </div>

                    <h2 className="
                        m-0
                        text-[22px]
                        font-bold
                        text-red-700
                    ">
                        Đọc tài liệu bằng OS BOOKS
                    </h2>

                    <p className="
                        mt-3 mb-5
                        text-[15px]
                        leading-6
                        text-gray-700
                    ">
                        {isIOS
                            ? "Trên iPhone và iPad, tài liệu chỉ được đọc bằng ứng dụng OS BOOKS. Vui lòng mở hoặc tải ứng dụng từ App Store để tiếp tục."
                            : "Trên thiết bị Android, tài liệu chỉ được đọc bằng ứng dụng Books OS. Vui lòng mở hoặc tải ứng dụng từ Google Play để tiếp tục."}
                    </p>

                    <a
                        href={booksOSStoreUrl}
                        className="
                            flex
                            min-h-[48px]
                            w-full
                            items-center
                            justify-center
                            rounded-xl
                            bg-red-600
                            px-5
                            text-[15px]
                            font-bold
                            text-white
                            no-underline
                            hover:bg-red-700
                            hover:text-white
                        "
                    >
                        {isIOS
                            ? "MỞ / TẢI OS BOOKS TRÊN APP STORE"
                            : "MỞ / TẢI BOOKS OS TRÊN GOOGLE PLAY"}
                    </a>

                    <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="
                            mt-3
                            min-h-[42px]
                            w-full
                            rounded-xl
                            border border-gray-200
                            bg-white
                            text-[14px]
                            font-medium
                            text-gray-700
                        "
                    >
                        Quay lại
                    </button>
                </div>
            </div>
        );
    }


    return (

        <div
            ref={wrapperRef}
            className="
                fixed
                inset-0
                z-[99999]

                bg-[#202124]

                flex
                flex-col
            "
        >

            <header
                className="
                    h-[52px]
                    md:h-[58px]

                    flex-shrink-0

                    flex
                    items-center

                    gap-1
                    md:gap-2

                    px-2
                    md:px-4

                    bg-[#17191c]

                    border-b
                    border-white/10

                    text-white

                    shadow-sm
                "
            >

                <button
                    type="button"
                    onClick={() =>
                        navigate(-1)
                    }
                    className="
                        h-9

                        px-2
                        md:px-3

                        flex
                        items-center
                        gap-2

                        rounded-lg

                        hover:bg-white/10

                        transition-colors

                        flex-shrink-0
                    "
                    title="Quay lại"
                >

                    <ArrowLeftOutlined />

                    <span
                        className="
                            hidden
                            sm:inline

                            text-sm
                            font-semibold
                        "
                    >
                        THƯ VIỆN
                    </span>

                </button>


                <div
                    className="
                        hidden
                        sm:block

                        w-px
                        h-6

                        bg-white/10
                    "
                />


                <div
                    className="
                        flex-1
                        min-w-0

                        flex
                        items-center

                        gap-2
                        md:gap-3
                    "
                >

                    <div
                        className="
                            hidden
                            md:flex

                            w-8
                            h-8

                            items-center
                            justify-center

                            rounded-lg

                            bg-white/10

                            flex-shrink-0
                        "
                    >
                        <FileTextOutlined />
                    </div>


                    <div className="min-w-0">

                        <div
                            className="
                                truncate

                                text-[13px]
                                md:text-[15px]

                                font-semibold
                            "
                        >
                            {title || "Tài liệu"}
                        </div>


                        <div
                            className="
                                hidden
                                sm:block

                                text-[10px]

                                text-gray-400

                                mt-[1px]
                            "
                        >
                            {loading
                                ? "Đang mở tài liệu..."
                                : "Đang đọc trực tuyến"}
                        </div>

                    </div>

                </div>


                <button
                    type="button"
                    onClick={reload}
                    className="
                        w-9
                        h-9

                        flex
                        items-center
                        justify-center

                        rounded-lg

                        hover:bg-white/10

                        transition-colors
                    "
                    title="Tải lại"
                >
                    <ReloadOutlined />
                </button>


                <button
                    type="button"
                    onClick={
                        toggleFullscreen
                    }
                    className="
                        w-9
                        h-9

                        flex
                        items-center
                        justify-center

                        rounded-lg

                        hover:bg-white/10

                        transition-colors
                    "
                    title={
                        fullscreen
                            ? "Thoát toàn màn hình"
                            : "Toàn màn hình"
                    }
                >

                    {fullscreen
                        ? <CompressOutlined />
                        : <ExpandOutlined />
                    }

                </button>

            </header>


            <main
                className="
                    relative

                    flex-1
                    min-h-0

                    bg-[#202124]
                "
            >

                {loading && (

                    <div
                        className="
                            absolute
                            inset-0

                            z-10

                            flex
                            items-center
                            justify-center

                            bg-[#202124]

                            pointer-events-none
                        "
                    >

                        <div
                            className="
                                flex
                                flex-col
                                items-center

                                text-gray-300
                            "
                        >

                            <div
                                className="
                                    w-8
                                    h-8

                                    rounded-full

                                    border-2
                                    border-white/20
                                    border-t-white

                                    animate-spin
                                "
                            />


                            <span
                                className="
                                    mt-3

                                    text-xs
                                "
                            >
                                Đang mở tài liệu
                            </span>

                        </div>

                    </div>
                )}


                {url ? (

                    <iframe
                        key={reloadKey}
                        src={url}
                        title={
                            title ||
                            "Tài liệu"
                        }
                        className="
                            absolute
                            inset-0

                            w-full
                            h-full
                        "
                        style={{
                            border: "none",
                            background:
                                "#202124"
                        }}
                        onLoad={() =>
                            setLoading(false)
                        }
                        allowFullScreen
                    />

                ) : (

                    <div
                        className="
                            absolute
                            inset-0

                            flex
                            items-center
                            justify-center

                            text-gray-300
                        "
                    >
                        Không tìm thấy tài liệu.
                    </div>

                )}

            </main>

        </div>
    );
};


export default PdfView;
